export default __webpack_public_path__ + "static/media/SOL.32f156f9.svg";